import { FieldObject } from '~/interfaces/field.interface';
import { NAModule } from '~/models/modules/NAModule.model';

export class MullerModule extends NAModule {
    hasOperationReset = false;
    hasOperationImportData = false;

    isWired = true;

    get fieldName(): FieldObject | undefined {
        return undefined;
    }
    get fieldSetupDate(): FieldObject | undefined {
        return undefined;
    }
    get fieldFirmware(): FieldObject | undefined {
        return undefined;
    }
    get fieldLastUpdate(): FieldObject | undefined {
        return undefined;
    }
    get fieldRoom(): FieldObject | undefined {
        return undefined;
    }
    get fieldRefurbished(): FieldObject | undefined {
        return undefined;
    }
    get fieldCustomer(): FieldObject | undefined {
        return undefined;
    }
    get fieldCommand(): FieldObject | undefined {
        return undefined;
    }
    get fieldCustomer2(): FieldObject | undefined {
        return undefined;
    }
    get fieldCommand2(): FieldObject | undefined {
        return undefined;
    }
}
